/*
 * Ryan O'Dowd
 * 2025-05-18
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import storage from 'redux-persist/lib/storage';

export default storage;
